import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './clienteForm';
import ProspeccaoForm from '../prospeccao/prospeccaoForm';
import ClienteUsuarioForm from './clienteUsuarioForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';

import { setModoTela, initForm, salvar, excluir, getLista, importar, getProspeccao, initFormUsuario, getListaUsuarioCompleto, salvarUsuario } from './clienteActions';
import { getListaCidade } from './endereco/enderecoActions';
import {
	salvar as salvarProspeccao, getListaProduto as getListaProdutoProspeccao, getListaCidade as getListaCidadeProspeccao, 
	getListaAtividade as getListaAtividadeProspeccao, getListaUsuario as getListaUsuarioProspeccao 
} from '../prospeccao/prospeccaoActions';

class Cliente extends Component {

	state = {
		linhaSelecionada: null,
		paginacaoIndice: 0
	}

	componentDidMount() {

		const fileSelector = document.createElement('input');
		fileSelector.setAttribute('type', 'file');
		fileSelector.addEventListener("change", async (data) => {

			let reader = new FileReader();
			let file = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files[0] : null;
			if (!file) {
				file = data && data.target && data.target.files && data.target.files[0] ? data.target.files[0] : null;
			}

			if (file) {

				if (!file.type.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
					|| (file.type.includes('application/excel') || file.type.includes('application/vnd.ms-excel'))) {
					setError('Selecione apenas (.XLSX)');
					return;
				}

				let tabela = [];
				await readXlsxFile(file, { sheet: 1 }).then((rows) => {
					tabela = rows;
				});

				this.props.importar(tabela);

				reader.readAsDataURL(file);

			}
		});

		this.fileSelector = fileSelector;

	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaCidade();
		this.props.getListaProdutoProspeccao();
		this.props.getListaCidadeProspeccao();
		this.props.getListaAtividadeProspeccao();
		this.props.getListaUsuarioProspeccao();
		this.props.getListaUsuarioCompleto();
    }

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
					{this.props.modoTela == 'endereco' ? (
						<Form endereco onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'prospeccao' ? (
						<ProspeccaoForm cliente onSubmit={this.props.salvarProspeccao} />
					) : null}
					{this.props.modoTela == 'usuario' ? (
						<ClienteUsuarioForm onSubmit={this.props.salvarUsuario} />
					) : null}
                </Content>
            </div>
        )
    }

	lista() {

		let lista = (this.props.lista).filter(item => {
			if (this.state.pesquisar
				&& !(`${item.id_petroshow} ${item.razao_social} ${item.nome_fantasia || ''} ${item.cnpj || ''} ${item.cpf || ''}`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
				return false;
			}
			return true;
		});

		let paginacao = [];

		for (let i = 0; i < this.props.lista.length; i += 500) {
			
			paginacao.push({
				inicio: i,
				fim: i + 499
			});
			
		}

		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({ id_tipo: 2 });
								}} />
						</Grid>
						{this.props.listaCidade.length > 0 &&
						<Grid cols='6 6 3 2'>
							<Button
								text='Importar'
								type={'primary'}
								icon={'fa fa-chevron-left'}
								event={() => {
									if (window.confirm('Remova a linha do cabeçalho do arquivo Excel (primeira linha) para depois importar')) {
										 this.fileSelector.click()
									}
								}} />
						</Grid>}
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
										
					<ul class='pagination pagination-sm m-0 float-right'>
						<li class='page-item'>
							<a class='page-link' 
								style={{ 
									cursor: 'pointer'
								}}
								onClick={() => this.setState({
									...this.state,
									paginacaoIndice: this.state.paginacaoIndice > 0 ? this.state.paginacaoIndice - 1 : this.state.paginacaoIndice
								})}>{'<<'}
							</a>
						</li>
						
						{paginacao.map((item, i) => (
							<li class='page-item'>
								<a class='page-link'  
									style={{ 
										fontWeight: 'bold',
										cursor: 'pointer',
										backgroundColor: i == this.state.paginacaoIndice ? '#007bff' : null,
										color: i == this.state.paginacaoIndice ? '#fff' : null
									}}
									onClick={() => this.setState({
										...this.state,
										paginacaoIndice: i
									})}>{i + 1}
								</a>
							</li>
						))}
						
						<li class='page-item'>
							<a class='page-link' 
								style={{ 
									cursor: 'pointer'
								}}
								onClick={() => this.setState({
									...this.state,
									paginacaoIndice: paginacao.length - 1 > this.state.paginacaoIndice ? this.state.paginacaoIndice + 1 : this.state.paginacaoIndice
								})}>{'>>'}
							</a>
						</li>
					</ul>

					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value, paginacaoIndice: 0 });
						}} />

					<Table responsive>
						<THead>
							<Tr>
								<Th>Código</Th>
								<Th>Razão Social</Th>
								<Th>Nome Fantasia</Th>
								<Th alignCenter>CNPJ / CPF</Th>
								<Th></Th>
							</Tr>
						</THead>
						<TBody>
							{lista.filter((item, i) => {
								return i >= paginacao[this.state.paginacaoIndice].inicio && i <= paginacao[this.state.paginacaoIndice].fim;
							}).map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td>{item.id_petroshow}</Td>
									<Td>{item.razao_social}</Td>
									<Td>{item.nome_fantasia}</Td>
									<Td alignCenter>{item.cnpj ? item.cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") : item.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")}</Td>
									<Td alignRight minWidth={150}>
										<ButtonTable
											type={'success'}
											icon={'fas fa-user-lock'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('usuario', {
													...item
												});
												let clienteUsuario = this.props.listaUsuarioCompleto.filter(usuario => usuario.id_cliente == item.id)[0];
												this.props.initFormUsuario(
													clienteUsuario ? {
														...clienteUsuario,
														cliente: { ...item }
													} : {
														id_cliente: item.id,
														cliente: { ...item },
														nome: item.nome_fantasia || item.razao_social,
														administrador: false,
														id_perfil: 20,
														login: item.cpf || item.cnpj,
													}
												);
											}} />

										<ButtonTable
											type={'success'}
											icon={'fas fa-id-badge'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.getProspeccao(item.id_petroshow);
											}} />

										<ButtonTable
											type={'primary'}
											icon={'fas fa-map-marker-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('endereco', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />
										
										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('cadastro', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />

										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('exclusao', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.cliente.modoTela,
	aguardando: state.cliente.aguardando,
	lista: state.cliente.lista,
	listaCidade: state.endereco.listaCidade,
	listaUsuarioCompleto: state.cliente.listaUsuarioCompleto
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, getLista, getListaCidade, importar, getProspeccao, salvarProspeccao,
	getListaProdutoProspeccao, getListaCidadeProspeccao, getListaAtividadeProspeccao, getListaUsuarioProspeccao,
	initFormUsuario, getListaUsuarioCompleto, salvarUsuario
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Cliente);
